import React from "react";
import "./WvManagedBadge.css";

/** Red checkmark SVG for Wv Managed badge */
const CheckIcon = () => (
  <svg
    className="wv-managed-check"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/**
 * Badge matching design: white bg, red border, red checkmark,
 * "W" black, "v" red, " Managed" black. Use "Wv" (not "Wz").
 */
export default function WvManagedBadge({ className = "", text = "" }) {
  return (
    <span className={`wv-managed-badge ${className}`.trim()}>
      <CheckIcon />
      <span className="wv-managed-text">
        <span className="wv-managed-w">W</span>
        <span className="wv-managed-v">v</span>
        <span className="wv-managed-word"> {text}</span>
      </span>
    </span>
  );
}
